<template>
    <svg
        :width="size"
        :height="size"
        fill="none"
        :stroke="color"
        :stroke-width="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <use
            v-bind="{
                'xlink:href': '#' + name
            }"
        />
    </svg>
</template>
<script>
export default {
    name: "MIcon",
    props: {
        name: {
            type: String,
            default: "circle"
        },
        size: {
            type: [Number, String],
            default: 18
        },
        stroke: {
            type: [Number, String],
            default: 1
        },
        color: {
            type: String,
            default: "currentColor"
        }
    }
};
</script>
<style scoped>
svg {
    display: inline-block;
    vertical-align: baseline;
}
</style>
